import { createStyles, StyledComponentProps, TextField, withStyles } from '@material-ui/core';
import Grid, { GridSize } from '@material-ui/core/Grid';
import { observer } from 'mobx-react';
import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import { transl } from '../../main/transl';
import { IOcResponse } from '../../services/CommSvc';
import { BranchDialogStore } from './BranchDialogStore';

interface BranchDialogProps {
	store: Instance<typeof BranchDialogStore>
	onAccept?: (branchId: number) => void
}

@observer class _BranchDialog extends React.Component<BranchDialogProps & StyledComponentProps> {
	_onAccept = () => {
		const {store, onAccept} = this.props;
		store.accept().then((r: IOcResponse) => onAccept && r.outputObject && onAccept(r.outputObject.id));
	}

	render() {
		const {classes, store} = this.props;
		if (!classes) return null; // impossible

		return <>
			<div className={classes.stepHeading}>
				{transl('location_add.step_1_1')}
			</div>
			<div className={classes.stepContent}>
				<BranchAddForm store={store}/>
			</div>
		</>;
	}
}

interface BranchAddFormProps {
	store: Instance<typeof BranchDialogStore>
}

@observer class _BranchAddForm extends React.Component<BranchAddFormProps & StyledComponentProps> {
	render() {
		const {classes, store} = this.props;
		if (!classes) return null; // impossible
		const fieldNames = [
			{ 'field': 'name', 'required': true, label: 'location.name', width: { xs: 12, sm: 12 } },
			{ 'field': 'street', width: { xs: 12, sm: 8 } },
			{ 'field': 'number', label: 'location.house_number', width: { xs: 12, sm: 4 } },
			{ 'field': 'zipcode', width: { xs: 12, sm: 4 } },
			{ 'field': 'town', width: { xs: 12, sm: 8 } },
			{ 'field': 'phone', width: { xs: 12, sm: 6 } },
			{ 'field': 'fax', width: { xs: 12, sm: 6 } }
		];
		return <Grid container spacing={3}>
			{
				fieldNames.map(n => <Grid item xs={(n.width.xs) as GridSize} sm={(n.width.sm) as GridSize} key={n.field}>
					<TextField
						className={classes.input}
						required={n.required}
						name={n.field}
						label={transl(n.label || n.field)}
						value={store[n.field]}
						error={n.required && !store[n.field]}
						onChange={store.applyEvent}
					>
					</TextField>
				</Grid>)
			}
		</Grid>;
	}
}

const styles = createStyles({
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
		width: '100%',
	},
	input: {
		width: '100%',
	},
	stepHeading: {
		fontWeight: 'bold'
	},
	stepContent: {
		padding: '10px 15%'
	}
});

export const BranchAddForm = withStyles(styles)(_BranchAddForm);

export const BranchDialog = withStyles(styles)(_BranchDialog);
